/**
 * Static presentation data for the three membership tiers.
 * Prices here are fallbacks only — live prices come from /getProducts.
 *
 * key      canonical plan name, matched against the product name
 * price    fallback contribution per person
 * featured highlights the tier in card grids
 * features marketing summary shown on plan cards
 */
export const PLAN_ORDER = ["AASHIRBAD", "HOI HULLOR", "UTSAV"];

export const PLAN_META = {
  AASHIRBAD: {
    price: 1500,
    features: [
      { text: "Dedicated queue for Anjali, Bhog & Maa Boron", on: true },
      { text: "Bhog — Saptami", on: true },
      { text: "Bhog — Ashtami & Nabami", on: true },
      { text: "Dandiya participation", on: false },
      { text: "Parking on availability", on: false },
      { text: "Gala dinner — Bijoya Dashami", on: false },
    ],
  },
  "HOI HULLOR": {
    price: 2250,
    features: [
      { text: "Everything in Aashirbad", on: true },
      { text: "Dandiya participation", on: true },
      { text: "Cultural program — external", on: true },
      { text: "In-house cultural program", on: true },
      { text: "Gala dinner — Bijoya Dashami", on: false },
      { text: "Bhog in Laxmi, Kaali & Saraswati Puja", on: false },
    ],
  },
  UTSAV: {
    price: 2650,
    featured: true,
    features: [
      { text: "Everything in Hoi Hullor", on: true },
      { text: "Parking on availability", on: true },
      { text: "Gala dinner — Bijoya Dashami", on: true },
      { text: "Bhog in Laxmi, Kaali & Saraswati Puja", on: true },
      { text: "Priority across all events", on: true },
      { text: "Lower rate for family of 3+", on: true },
    ],
  },
};

/**
 * Detailed matrix for the comparison modal.
 * group rows introduce a section; availability follows PLAN_ORDER.
 */
export const PLAN_COMPARISON = [
  { group: "Features" },
  { label: "Member dedicated queue for Anjali, Bhog & Maa Boron *", availability: [true, true, true] },
  { label: "Parking (on availability)", availability: [false, false, true] },
  { label: "Bhog — Saptami", availability: [true, true, true] },
  { label: "Bhog — Ashtami & Nabami", availability: [true, false, true] },
  { label: "Dandiya participation", availability: [false, true, true] },
  { label: "Cultural program — external", availability: [false, true, true] },
  { label: "Participation in in-house cultural program", availability: [false, true, true] },
  { label: "Gala dinner — Bijoya Dashami **", availability: [false, false, true] },
  { label: "Bhog in Laxmi, Kaali & Saraswati Puja **", availability: [false, false, true] },
];

export const PLAN_FOOTNOTES = [
  {
    marker: "*",
    text: "Members share a dedicated queue (shorter waiting time), not preference over non-members.",
  },
  {
    marker: "**",
    text: "Subject to surplus-fund availability.",
  },
];

export const PLAN_TIP =
  "UTSAV contribution is lower for a family of three or more members.";

const normalise = (value) => String(value || "").toUpperCase().replace(/[^A-Z0-9]/g, "");

const CODE_TO_PLAN = { MUTV: "UTSAV" };

export const planKeyFor = (product) => {
  if (!product) return null;
  if (CODE_TO_PLAN[product.code]) return CODE_TO_PLAN[product.code];
  const name = normalise(product.name);
  return PLAN_ORDER.find((key) => name.includes(normalise(key))) || null;
};

export const planMetaFor = (product) => PLAN_META[planKeyFor(product)] || null;
